import Helper from "@/common/helper.js"


export default class SquareSelectOrderModel  {

    timestamp: string| undefined;

    /*
        NOTE: not populating all the properties here. 
        It's time consuming and doesn't affect the usage of this class. 
        Easier to just define the fields in the server code.
        Will use this pattern going forward.
    */


    get timestampDisplay(): string {        
        let local = Helper.convertUTCDateToLocalDate(new Date(this.timestamp!))
        return local.toDateString().substring(4) + ", " + local.toLocaleTimeString()
    }


    static from(json: string): SquareSelectOrderModel {
        let model = Object.assign(new SquareSelectOrderModel(), json);
                
        return model;
    }
}